import { NavLink } from 'react-router-dom';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';
import { useBreadcrumbStore, useCourseStore } from '../../stores/courses';

export const ResoucesViewMemberIdUnitIdBreadcrumb: BreadcrumbComponentType<
	'memberId' | 'unitId' | 'lessonId' | 'resourceId'
> = ({ match }) => {
	const course = useCourseStore((state) => state.course);
	const breadcrumbs = useBreadcrumbStore((state) => state.breadcrumbs);
	const unit = course?.Units.find((u) => u.Unit.id === match.params.unitId);

	if (unit) {
		return (
			<NavLink
				to={`/units/index/${match.params.memberId}?unitId=${match.params.unitId}`}
			>
				{unit.Unit.name}
			</NavLink>
		);
	}

	if (breadcrumbs.length > 1) {
		return <NavLink to={breadcrumbs[1].url}>{breadcrumbs[1].name}</NavLink>;
	}

	return null;
};
